import {
  RadioGroup,
  RadioGroupCardItem
} from '@library/components/shadcn/radio-group';
import DepositMatchImage from '@library/assets/images/promotions/DepositMatch.png';
import FlashSaleImage from '@library/assets/images/promotions/FlashSale.png';
import { FormActionButtons } from '@library/components/buttons';
import FreeEntryPromotionImage from '@library/assets/images/promotions/FreeEntryPromotion.png';
import { PROMOTION_TYPES } from '@library/types/promotions';
import PayoutBoostImage from '@library/assets/images/promotions/PayoutBoost.png';
import ProtectedPlayImage from '@library/assets/images/promotions/ProtectedPlay.png';
import { formatLabelByPromotionType } from '@library/utils/promotions';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const images: Record<string, Record<string, string>> = {
  DepositMatch: {
    img: DepositMatchImage,
    border: 'data-[state=checked]:border-[#CDAE87]'
  },
  FlashSale: {
    img: FlashSaleImage,
    border: 'data-[state=checked]:border-[#FFC301]'
  },
  FreeEntryPromotion: {
    img: FreeEntryPromotionImage,
    border: 'data-[state=checked]:border-[#FF44BF]'
  },
  PayoutBoost: {
    img: PayoutBoostImage,
    border: 'data-[state=checked]:border-[#6ABA14]'
  },
  ProtectedPlay: {
    img: ProtectedPlayImage,
    border: 'data-[state=checked]:border-[#A40FFF]'
  }
};

export const PromotionTypeRadioGroup = () => {
  const [selectedCampaignType, setSelectedCampaignType] =
    useState<string>('OneTime');
  const [selectedPromotion, setSelectedPromotion] = useState<string | null>(
    null
  );
  const navigate = useNavigate();

  const handleContinueClick = () => {
    navigate(`?type=${selectedPromotion}&campaign=${selectedCampaignType}`);
  };

  const handleCancelClick = () => {
    navigate('/promotions');
  };

  return (
    <>
      <RadioGroup
        className="mt-4 grid max-w-full grid-cols-3 items-stretch gap-6 py-4"
        defaultValue="OneTime"
        onValueChange={(v) => setSelectedCampaignType(v)}
      >
        <RadioGroupCardItem
          value="OneTime"
          id="one-time"
          label="One-Time"
          description="Single, pre-scheduled promotion sent out once. Does not repeat."
        />
        <RadioGroupCardItem
          value="Recurring"
          id="recurring"
          label="Recurring"
          description="Automatically distributed on a recurring schedule."
        />
        <RadioGroupCardItem
          value="DynamicTrigger"
          id="dynamic-trigger"
          label="Dynamic Trigger"
          description="Awarded in real-time in response to an action taken by the member."
        />
      </RadioGroup>
      <hr className="border-t-soFresh-140 mt-2" />
      <RadioGroup
        className="mt-4 grid max-w-full grid-cols-3 items-stretch gap-6 py-4"
        onValueChange={(v) => setSelectedPromotion(v)}
      >
        {PROMOTION_TYPES.map((promoType) => (
          <RadioGroupCardItem
            className={`h-24 overflow-hidden ${images[promoType].border}`}
            key={promoType}
            value={promoType}
            label={formatLabelByPromotionType(promoType)}
            id={promoType}
          >
            <img
              src={images[promoType].img}
              alt={promoType}
              className="absolute -right-px -top-px h-24"
            />
          </RadioGroupCardItem>
        ))}
      </RadioGroup>
      <FormActionButtons
        primary={{
          onClick: handleContinueClick,
          label: 'Continue',
          disabled: !selectedPromotion || !selectedCampaignType
        }}
        secondary={{ onClick: handleCancelClick, label: 'Cancel' }}
      />
    </>
  );
};
